(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/views/pages/result-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/views/pages/result-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.eurojackpot=_svs.eurojackpot||{};
_svs.eurojackpot.templates=_svs.eurojackpot.templates||{};
svs.eurojackpot.templates.result_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngResultRegion\"></div>\n\n";
},"useData":true});
Handlebars.partials['svs-eurojackpot-result_page'] = svs.eurojackpot.templates.result_page;
})(svs, Handlebars);


 })(window);